<template>
  <div id="ooowin" class="has-fix-top padding_top_80">
    <new-header></new-header>
    <div class="padding_top_40   w_bg">
      <div class="main_cont  clearfix">
        <div class="fl left-cont">
            <Carousel autoplay v-model="img_new_show" loop  v-if="top_img.length > 0" :autoplay-speed="4000" class="margin_bottom_40" dots="none" arrow="never">
                <CarouselItem v-for="item in top_img" :key="item.newsId">
                    <div class="top_img border_gray img_width_100 cursor_p" @click="getDetail(item.newsId)">
                        <img :src="item.coverUrl"/>
                        <p class="black_opacity_bg w_color position_a font_20 padding_level_20">{{item.title}}</p>
                    </div>
                </CarouselItem>
            </Carousel>
            <div class="top_btns  gray_bg center font_14 margin_bottom_50 top_title_color">
              <ul class="clearfix">
                <li :class="{'ac_bg w_color':searchForm.newsType == item.id}" v-for="(item,index) in news_kind" :key="index" @click="choseType(item.id)">{{item.name}}</li>
              </ul>
            </div>
            <div class="cont_main_list">
                <ul>
                  <li @click="getDetail(item.newsId)" v-for="(item,index) in news_main_list" :key="index"
                        class="clearfix  margin_bottom_50 cursor_p" :class="{'border_gray_bottom':index<news_main_list.length-1}">
                      <div class="fl img_width_100 border_gray img_box margin_bottom_50">
                        <img :src="item.coverUrl"/>
                      </div>
                      <div class="fr right_cont">
                        <p class="cont_title font_16 title_color margin_bottom_5">{{item.title}}</p>
                        <p class="cont_font font_14 cont_color margin_bottom_10 line_2">{{item.intro.substr(0,70)+ (item.intro.length > 70 ? '...':'')}}</p>
                        <div class="bottom_list clearfix cont_color font_12">
                            <!-- <p class="fl cont_time padding_left_20 margin_right_20">{{item.createTime.split(' ')[0]}}</p> -->
                            <p class="fl cont_time padding_left_20 margin_right_20">{{timestampToTime(item.createTime)}}</p>
                            <p class="fl cont_source padding_left_20">{{item.newsSource}}</p>
                            <ul class="cont_label clearfix fr">
                                <li v-for="(inItem,index) in item.tagNames.split(',').slice(0,3)" :key="index" class="border_gray gray_bg border_radius_3 margin_left_20 padding_level_5">{{inItem}}</li>
                            </ul>
                        </div>
                      </div>
                  </li>
                </ul>
                <Page :total="total" v-show="total > searchForm.pageSize" :page-size="searchForm.pageSize" @on-change="changePage" class="center margin_bottom_30"></Page>
            </div>
        </div>
        <div class="fr right-cont">
            <ul class="top_img margin_bottom_40"  v-if="top_img.length > 0">
              <li class="border_gray position_r cursor_p" v-for="(item,index) in top_img" :key="index"
                  :class="{'margin_bottom_20':index<top_img.length-1,'ac':img_new_show == index}"
                  @click="img_new_show = index">
                <div class="img_width_100">
                  <img :src="item.coverUrl"/>
                  <p class="black_opacity_bg w_color position_a font_14 padding_level_20">{{item.title}}</p>
                </div>
              </li>
            </ul>
            <p class="left_icon position_r font_18 top_title_color padding_bottom_20 border_gray_bottom padding_left_20 margin_bottom_15">热门文章</p>
            <ul class="hot_news" v-if="hot_news.length > 0">
              <li @click="getDetail(item.newsId)" v-for="item in hot_news" :key="item.newsId" class="nowrap font_14 title_color margin_bottom_10 padding_left_20 position_r cursor_p">{{item.title}}</li>
            </ul>
        </div>
        <div class="to_top border_gray gray_bg border_radius_3 cursor_p" :style="{left:to_top_left+'px'}" @click="toTop">
          <span></span>
        </div>
      </div>
    </div>
    <PageFooter></PageFooter>
  </div>
</template>
<script>
import newHeader from '@components/common/newHeader.vue';
import PageFooter from '@components/common/PageFooter.vue';
import PageCenter from '@components/common/PageCenter.vue';
export default {
  name: 'app',
  data(){
    return{
        img_new_show:0,
        top_img:[//顶部3个推荐资讯
            {}],
        news_kind:[],//资讯类型
        news_main_list:[],//全部资讯
        hot_news:[],
        to_top_left:0,
        searchForm:{
            newsType:'9999',//当前显示的资讯类型
            pageSize:10,
            pageNum:1
        },
        total:0
    }
  },
  mounted:function (){
    let winW = window.innerWidth;
    this.to_top_left = winW<1200+140 ? winW-70 :winW/2+620;
    this.getTopNewes();
      this.getHotNews();
      this.getNewsType();
      this.getAllNews();
  },
  created:function(){

  },
  watch:{
  },
  computed:{
  },
  methods:{
    timestampToTime(timestamp) {
        timestamp = timestamp ? timestamp : null;
        let date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + '-';
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
        let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
        let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        return Y + M + D + h + m + s;
      },
      getTopNewes(){
          this.ajax.get('web/news/topNewes',{}).then(res => {
              this.top_img = res.data || [];
          })
      },
      getHotNews(){
          this.ajax.get('web/news/hotNewes',{}).then(res => {
             this.hot_news = res.data || [];
          })
      },
      getNewsType(){
          this.ajax.get('common/dictionary/newsTypes',{}).then(res => {
              let data = res.data || [];
              let news_kind = [];
                data = [{
                    id:9999,
                    name:'全部资讯'
                },...data]
                 data.map(item => {
                     news_kind.push({
                        id : item.id.toString(),
                        name :item.name
                     })
                 })
              this.news_kind = news_kind;
          })
      },
      getAllNews(){
          let searchForm = this.searchForm;
          let obj = {
              pageSize:searchForm.pageSize,
              pageNum:searchForm.pageNum
          };
          if(searchForm.newsType!="9999"){
              obj.newsType = searchForm.newsType;
          }
          this.ajax.get('web/news/newes',obj).then(res => {
              this.news_main_list = (res.data&&res.data.list) || [];
              this.total = res.data&&res.data.total;
          })
      },
      choseType(typeId){
          this.searchForm.newsType = typeId;
          this.getAllNews();
      },
      getDetail(id){//去详情介绍
          window.location.href = './news_desc.html?id='+id;
      },
      changePage(index){
          this.searchForm.pageNum = index;
          this.getAllNews();
      },
      toTop(){
          window.scroll(0,0);
      }
  },
  components:{
    PageFooter,PageCenter,newHeader
  }
}
</script>
<style lang="scss" scoped>
    @import "./index.scss";

</style>
